"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3687,2206],{

/***/ 22206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LibrarySkeleton": function() { return /* binding */ LibrarySkeleton; },
/* harmony export */   "ManualRecordButton": function() { return /* binding */ ManualRecordButton; },
/* harmony export */   "ProductNameTranslateToggle": function() { return /* binding */ ProductNameTranslateToggle; },
/* harmony export */   "useDateList": function() { return /* binding */ useDateList; },
/* harmony export */   "useEnumDate": function() { return /* binding */ useEnumDate; },
/* harmony export */   "useEnumDateGmv": function() { return /* binding */ useEnumDateGmv; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _pages_library_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86902);
/* harmony import */ var _utils_useLocale__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83126);
/* harmony import */ var _components_EchoCard__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2917);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(56187);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(77303);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(15695);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(65979);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(749);
/* harmony import */ var _arco_design_web_react_icon__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(84566);
/* harmony import */ var _hooks_useUrlSyncParams__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30484);
/* harmony import */ var _assets_ic_search_png__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11868);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _components_CollectButton__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(77960);
/* harmony import */ var _api_favorites__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(66375);
/* harmony import */ var _utils_generateExportUrl__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(86489);
/* harmony import */ var _style_index_module_less__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(98173);
/* harmony import */ var _style_index_module_less__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(_style_index_module_less__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var _components_Mask__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(2852);
/* harmony import */ var _api_product__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(43687);
/* harmony import */ var _components_SEOHeader__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(47742);
/* harmony import */ var _custom_render__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(16390);
/* harmony import */ var _hooks_useTable__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(23218);
/* harmony import */ var _components_Search__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(67320);
/* harmony import */ var _types_common__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(43397);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(25617);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(26638);
/* harmony import */ var _hooks_useRegionOptions__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(3770);
/* harmony import */ var _utils_moduleCode__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(61710);
/* harmony import */ var ahooks__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(65885);
/* harmony import */ var ahooks__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(78234);
/* harmony import */ var _utils_is__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(1405);
/* harmony import */ var _hooks_useSWRApi__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(3973);
/* harmony import */ var _pages_platform_leaderboard_products_leaderboard__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(17254);
/* harmony import */ var _components_CustomTableField__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(70736);
/* harmony import */ var _hooks_useCustomField__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(669);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(42586);
/* harmony import */ var _hooks_useIsZh__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(2828);
/* harmony import */ var _components_ManualRecordModal__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(19790);
/* harmony import */ var _components_business_table_secondary_currency__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(42882);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









































const ManualRecordButton = _ref => {
  let {
    type
  } = _ref;
  const t = (0,_utils_useLocale__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
  const {
    0: manualRecordVisible,
    1: setManualRecordVisible
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_33__/* ["default"] */ .Z, {
      type: "primary",
      size: "large",
      onClick: () => setManualRecordVisible(true),
      className: (_style_index_module_less__WEBPACK_IMPORTED_MODULE_34___default().manualRecordBtn),
      icon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_arco_design_web_react_icon__WEBPACK_IMPORTED_MODULE_35__/* ["default"] */ .Z, {}),
      children: t['manual_record']
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_components_ManualRecordModal__WEBPACK_IMPORTED_MODULE_30__/* ["default"] */ .Z, {
      visible: manualRecordVisible,
      onCancel: () => setManualRecordVisible(false),
      successCallback: data => {
        console.log(data);
      },
      type: type
    })]
  });
};
const useEnumDate = () => {
  const t = (0,_utils_useLocale__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
  return {
    '1': t['product.column.sales_yesterday'],
    '7': t['product.column.sales_day7'],
    '30': t['product.column.sales_day30'],
    '90': t['product.column.sales_day90']
  };
};
const useEnumDateGmv = () => {
  const t = (0,_utils_useLocale__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
  return {
    '1': t['product.column.gmv_yesterday'],
    '7': t['product.column.gmv_day7'],
    '30': t['product.column.gmv_day30'],
    '90': t['product.column.gmv_day90']
  };
};
const useDateList = () => {
  const t = (0,_utils_useLocale__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
  return [{
    label: t['product.filter.yesterday'],
    value: '1'
  }, {
    label: t['product.filter.last_week'],
    value: '7'
  }, {
    label: t['product.filter.last_month'],
    value: '30'
  }];
};
const ProductNameTranslateToggle = () => {
  const isZh = (0,_hooks_useIsZh__WEBPACK_IMPORTED_MODULE_29__/* .useIsZh */ .r)();
  const t = (0,_utils_useLocale__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
  const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_20__/* .useDispatch */ .I0)();
  const productNameTranslate = (0,react_redux__WEBPACK_IMPORTED_MODULE_20__/* .useSelector */ .v9)(state => state.global.productNameTranslate);
  const [isTranslate, setIsTranslate] = (0,ahooks__WEBPACK_IMPORTED_MODULE_36__/* ["default"] */ .Z)(_utils_constants__WEBPACK_IMPORTED_MODULE_37__/* .PRODUCT_NAME_TRANSLATE_STORAGE_KEY */ .Dr, {
    defaultValue: false
  }); // 初始化时同步localStorage的值到Redux (只在组件挂载时执行一次)

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    if (isTranslate !== productNameTranslate) {
      dispatch((0,_store__WEBPACK_IMPORTED_MODULE_21__/* .updateProductNameTranslate */ .kD)(isTranslate));
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);

  const handleTranslate = () => {
    const newTranslateState = !isTranslate;
    setIsTranslate(newTranslateState); // 同步更新Redux状态

    dispatch((0,_store__WEBPACK_IMPORTED_MODULE_21__/* .updateProductNameTranslate */ .kD)(newTranslateState));
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsxs)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)("span", {
      children: isZh ? '一键翻译' : t['product.column.productName']
    }), isZh ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)("div", {
      className: "flex items-center",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_39__/* ["default"] */ .Z, {
        content: t['product_name_translate_english'],
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_40__/* ["default"] */ .Z, {
          checked: isTranslate,
          onChange: handleTranslate,
          size: "small"
        })
      })
    }) : null]
  });
};

const useColumns = dateRangeParam => {
  const t = (0,_utils_useLocale__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
  const router = (0,next_router__WEBPACK_IMPORTED_MODULE_19__.useRouter)();
  const dateRange = dateRangeParam || router.query.dateRange;
  const ENUM_DATE = useEnumDate();
  const ENUM_DATE_GMV = useEnumDateGmv();
  const list = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(() => {
    return [{
      title: t['product.column.productName'],
      dataIndex: 'product_name',

      render(_, record) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_custom_render__WEBPACK_IMPORTED_MODULE_15__/* .RenderProductListColumn */ .m2, {
          record: record
        });
      },

      width: 360,
      headerCellStyle: {
        padding: '5px 0'
      }
    }, {
      title: t['relation_shop'],
      dataIndex: 'seller',
      width: 210,
      render: (_, record) => {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_pages_platform_leaderboard_products_leaderboard__WEBPACK_IMPORTED_MODULE_26__/* .RelationShop */ .u1, {
          record: record.seller
        });
      },
      align: 'center'
    }, {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      title: ENUM_DATE[dateRange] || ENUM_DATE[_hooks_useUrlSyncParams__WEBPACK_IMPORTED_MODULE_5__/* .DATE_RANGE_PRODUCT */ .yq],
      dataIndex: 'total_sale_nd_cnt',
      render: val => {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_components_Mask__WEBPACK_IMPORTED_MODULE_12__/* .MaskValue */ .Rg, {
          value: val,
          style: {
            color: '#EB50AA'
          }
        });
      },
      width: 90,
      defaultSortOrder: 'descend',
      openSort: true,
      align: 'center'
    }, {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      title: ENUM_DATE_GMV[dateRange] || ENUM_DATE_GMV[_hooks_useUrlSyncParams__WEBPACK_IMPORTED_MODULE_5__/* .DATE_RANGE_PRODUCT */ .yq],
      dataIndex: 'total_sale_gmv_nd_amt',
      render: (_, record) => {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_components_business_table_secondary_currency__WEBPACK_IMPORTED_MODULE_31__/* .TableSecondaryCurrency */ .h, {
          record: record,
          filedName: "total_sale_gmv_nd_amt"
        });
      },
      align: 'center',
      defaultSortOrder: 'descend',
      width: 100,
      openSort: true
    }, {
      title: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_custom_render__WEBPACK_IMPORTED_MODULE_15__/* .ProductTrendTitle */ .Ww, {}),
      dataIndex: 'sales_trending',
      width: 140,
      align: 'center'
    }, {
      title: t['influencer.detail.basic.contents.trend.sales.total'],
      dataIndex: 'total_sale_cnt',
      render: _components_Mask__WEBPACK_IMPORTED_MODULE_12__/* .renderMaskValue */ .EF,
      align: 'center',
      openSort: true
    }, {
      title: t['workplace.GMV'],
      dataIndex: 'total_sale_gmv_amt',
      render: (_, record) => {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_components_business_table_secondary_currency__WEBPACK_IMPORTED_MODULE_31__/* .TableSecondaryCurrency */ .h, {
          record: record,
          filedName: "total_sale_gmv_amt"
        });
      },
      align: 'center',
      openSort: true
    }, {
      title: t['product.column.influencersCount'],
      dataIndex: 'influencers_count',
      render: _components_Mask__WEBPACK_IMPORTED_MODULE_12__/* .renderMaskValue */ .EF,
      align: 'center',
      openSort: true
    }, {
      title: t['influencer.detail.Related.video_count'],
      dataIndex: 'videos_count',
      render: _components_Mask__WEBPACK_IMPORTED_MODULE_12__/* .renderMaskValue */ .EF,
      align: 'center',
      openSort: true
    }]; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateRange, t]);
  return list;
};

const useProductDateList = () => {
  const t = (0,_utils_useLocale__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
  return [{
    label: t['product.filter.yesterday_sales'],
    value: '1'
  }, {
    label: t['product.filter.last_week_sales'],
    value: '7'
  }, {
    label: t['product.filter.last_month_sales'],
    value: '30'
  }, {
    label: t['product.filter.last90_sales'],
    value: '90'
  }];
};

const LOCAL_ID = 'products_columns';
const Products = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(props => {
  var _filtersFromSSR$more_, _filtersFromSSR$more_2, _filtersFromSSR$more_3, _filtersFromSSR$more_4, _filtersFromSSR$more_5, _filtersFromSSR$more_6, _filtersFromSSR$more_7;

  const t = (0,_utils_useLocale__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
  const {
    paramsFromSSR,
    ssrCtx,
    filtersFromSSR
  } = props;
  const {
    currency
  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_20__/* .useSelector */ .v9)(state => state.ssr);
  const {
    searchType
  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_20__/* .useSelector */ .v9)(state => state.global);
  const {
    regionOptions
  } = (0,_hooks_useRegionOptions__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(); // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

  const activeRegion = regionOptions.find(item => item.value === currency);
  const router = (0,next_router__WEBPACK_IMPORTED_MODULE_19__.useRouter)();
  const {
    0: currentSEOCategories,
    1: setCurrentSEOCategories
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
  const {
    0: currentKeyword,
    1: setCurrentKeyword
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)('');
  const {
    filtersFromSSR: threeLevelCategoriesFromCSR,
    isLoading: threeLevelCategoriesLoading
  } = (0,_hooks_useSWRApi__WEBPACK_IMPORTED_MODULE_25__/* .useThreeLevelCategoriesLocalStorage */ .Ho)({
    ssrCtx
  });
  const columnList = useColumns();
  const dateList = useProductDateList();
  const {
    0: resetFlag,
    1: setResetFlag
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
  const {
    defaultColumns,
    customFields,
    setCustomFields
  } = (0,_hooks_useCustomField__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z)({
    id: LOCAL_ID,
    rawColumns: columnList,
    disabledKeys: ['product_name', 'seller']
  });
  const pinColumns = [{
    title: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(ProductNameTranslateToggle, {}),
    dataIndex: 'product_name',

    render(_, record) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_custom_render__WEBPACK_IMPORTED_MODULE_15__/* .RenderProductListColumn */ .m2, {
        record: record
      });
    },

    width: 360,
    fixed: 'left',
    headerCellStyle: {
      padding: '5px 0'
    }
  }, {
    title: t['relation_shop'],
    dataIndex: 'seller',
    width: 210,
    render: (_, record) => {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_pages_platform_leaderboard_products_leaderboard__WEBPACK_IMPORTED_MODULE_26__/* .RelationShop */ .u1, {
        record: record.seller
      });
    },
    align: 'center'
  }];
  const finalColumns = [...pinColumns, ...customFields.map(item => _objectSpread(_objectSpread({}, item), {}, {
    align: 'center'
  })), {
    title: t['common.list.action'],
    dataIndex: '',
    align: 'center',
    width: 100,
    fixed: 'right',

    render(_, record) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsxs)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
          href: `/products/${record.product_id}`,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)("a", {
            target: "_blank",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)("div", {
              style: {
                width: 32,
                height: 32
              },
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_8___default()), {
                src: _assets_ic_search_png__WEBPACK_IMPORTED_MODULE_6__/* ["default"].src */ .Z.src,
                width: 32,
                height: 32
              })
            })
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_components_CollectButton__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
          type: "products",
          id: record.product_id,
          collectStatus: record.collect_status.id,
          onCollect: () => (0,_api_favorites__WEBPACK_IMPORTED_MODULE_10__/* .starProductApi */ .B_)(record.product_id),
          onUnCollect: () => (0,_api_favorites__WEBPACK_IMPORTED_MODULE_10__/* .unStarProductApi */ .l7)(record.product_id)
        })]
      });
    }

  }];

  const handleExport = key => {
    const commonParams = _objectSpread(_objectSpread({}, params), {}, {
      type: searchType
    });

    const query = key ? _objectSpread(_objectSpread({}, commonParams), {}, {
      export_count: key
    }) : commonParams;
    window.open((0,_utils_generateExportUrl__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
      url: `/data/products/list/export`,
      query: query
    }));
  };

  const sortList = [{
    title: t['shops.avg_price'],
    dataIndex: 'avg_price',
    openSort: true
  }, ...columnList].filter(column => column.openSort);
  const {
    renderTable,
    params,
    setParams,
    table
  } = (0,_hooks_useTable__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .ZP)({
    getTableApi: _api_product__WEBPACK_IMPORTED_MODULE_13__/* .getProductListApi */ .OX,
    columns: finalColumns,
    paramsFromSSR,
    tableFromSSR: {
      isLoading: false,
      list: [],
      page: {
        current: 1,
        total: 0,
        pageSize: 10
      }
    },
    rowKey: 'product_id',
    onExport: handleExport,
    title: t['product.column.product_list'],
    sortList: sortList,
    moduleCode: _utils_moduleCode__WEBPACK_IMPORTED_MODULE_23__/* .ModuleCode["library.filters"] */ .z["library.filters"],
    getChartsApi: _api_product__WEBPACK_IMPORTED_MODULE_13__/* .getProductTrendsListApi */ .PT,
    chartDataIndex: 'sales_trending',
    exportId: 'export.products',
    customField: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_components_CustomTableField__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z, {
      id: LOCAL_ID,
      onOk: list => {
        const newList = list.map(l => {
          var _columnList$find;

          return {
            dataIndex: l.dataIndex,
            isSelected: l.isSelected,
            title: (_columnList$find = columnList.find(i => i.dataIndex === l.dataIndex)) === null || _columnList$find === void 0 ? void 0 : _columnList$find.title
          };
        }).filter(item => item.isSelected === true);
        setCustomFields(newList);
      },
      defaultFields: defaultColumns
    })
  });
  (0,_hooks_useUrlSyncParams__WEBPACK_IMPORTED_MODULE_5__/* .useUrlSyncParams */ .Qw)(params);

  const renderSEOTitle = () => {
    return `${t['seo.top']} ${(currentSEOCategories === null || currentSEOCategories === void 0 ? void 0 : currentSEOCategories.label) || ''} ${t['seo.tiktok_product']}`;
  };

  const handleChangeSEOTitle = nextParams => {
    const productCategories = nextParams.product_categories;

    if (productCategories !== undefined && Array.isArray(productCategories)) {
      const curId = productCategories[0];
      const curObj = threeLevelCategoriesFromCSR === null || threeLevelCategoriesFromCSR === void 0 ? void 0 : threeLevelCategoriesFromCSR.find(item => item.value === curId);
      setCurrentSEOCategories(curObj);
    }
  };

  (0,ahooks__WEBPACK_IMPORTED_MODULE_41__/* ["default"] */ .Z)(() => {
    const {
      product_categories
    } = router.query;

    if (product_categories) {
      handleChangeSEOTitle({
        product_categories
      });
    }
  });

  const handleSearch = val => {
    const obj = (0,_hooks_useUrlSyncParams__WEBPACK_IMPORTED_MODULE_5__/* .initParams */ .MH)(params);
    setParams(_objectSpread(_objectSpread({}, obj), {}, {
      keyword: val,
      page: '1',
      type: searchType
    }));
  };

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    const keyWord = router.query.keyword;

    if (keyWord && router.query.isGlobalSearch) {
      handleSearch(keyWord);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [router.query.keyword]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_components_SEOHeader__WEBPACK_IMPORTED_MODULE_14__/* .SEOHeader */ .h, {
      title: renderSEOTitle(),
      description: t['product.seo.meta.description'].replace('{category}', (currentSEOCategories === null || currentSEOCategories === void 0 ? void 0 : currentSEOCategories.label) || ''),
      keywords: t['seo.products.library.keywords']
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsxs)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z, {
      direction: "vertical",
      size: 16,
      style: {
        width: '100%'
      },
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsxs)("div", {
        className: (_style_index_module_less__WEBPACK_IMPORTED_MODULE_34___default().header),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)("h1", {
          className: (_style_index_module_less__WEBPACK_IMPORTED_MODULE_34___default().title),
          style: {
            minWidth: 100
          },
          children: t['product.name']
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsxs)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_components_Search__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
            theme: "light",
            defaultType: _types_common__WEBPACK_IMPORTED_MODULE_18__/* .SearchTypes.Product */ .ai.Product,
            defaultValue: paramsFromSSR.keyword,
            onSearch: value => {
              handleSearch(value);
            },
            setCurrentKeyword: keyword => setCurrentKeyword(keyword),
            autoJumpWhenTypeChange: true,
            resetFlag: resetFlag,
            searchByImage: true,
            imageSearchLoading: table === null || table === void 0 ? void 0 : table.isLoading,
            onImageSearch: (resData, keyword) => {
              const obj = (0,_hooks_useUrlSyncParams__WEBPACK_IMPORTED_MODULE_5__/* .initParams */ .MH)(params);
              setParams(_objectSpread(_objectSpread({}, obj), {}, {
                image: resData,
                page: '1',
                keyword
              }));
            },
            onImageSearchClose: () => {
              //参数重置
              setParams(_objectSpread(_objectSpread({}, params), {}, {
                image: '',
                keyword: ''
              }));
            }
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(ManualRecordButton, {
            type: "product"
          })]
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsxs)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z, {
        direction: "vertical",
        size: 24,
        style: {
          width: '100%'
        },
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_pages_library_filter__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
          showCustomFilter: true,
          id: "products",
          loading: threeLevelCategoriesLoading,
          categoryFilters: [{
            label: t['filter.productCategories'],
            key: 'product_categories',
            categories: filtersFromSSR === null || filtersFromSSR === void 0 ? void 0 : filtersFromSSR.product_categories,
            threeLevelList: threeLevelCategoriesFromCSR,
            resultLabel: t['filter.productCategories']
          }],
          basicFilters: [{
            key: 'price',
            label: t['product.column.price'],
            options: filtersFromSSR === null || filtersFromSSR === void 0 ? void 0 : (_filtersFromSSR$more_ = filtersFromSSR.more_filters) === null || _filtersFromSSR$more_ === void 0 ? void 0 : _filtersFromSSR$more_.price,
            type: 'selectInput'
          }, {
            label: t['video.detail.comments'],
            key: 'review_count',
            type: 'selectInput',
            options: filtersFromSSR === null || filtersFromSSR === void 0 ? void 0 : (_filtersFromSSR$more_2 = filtersFromSSR.more_filters) === null || _filtersFromSSR$more_2 === void 0 ? void 0 : _filtersFromSSR$more_2.review_count
          }, {
            label: t['product.detail.rating'],
            key: 'product_rating',
            type: 'selectInput',
            options: filtersFromSSR === null || filtersFromSSR === void 0 ? void 0 : (_filtersFromSSR$more_3 = filtersFromSSR.more_filters) === null || _filtersFromSSR$more_3 === void 0 ? void 0 : _filtersFromSSR$more_3.product_rating
          }, {
            key: 'commission_rate',
            options: filtersFromSSR === null || filtersFromSSR === void 0 ? void 0 : (_filtersFromSSR$more_4 = filtersFromSSR.more_filters) === null || _filtersFromSSR$more_4 === void 0 ? void 0 : _filtersFromSSR$more_4.commission_rate,
            type: 'selectInput',
            label: t['product.column.commission_rate']
          }, {
            label: t['product.column.influencersCount'],
            key: 'related_influencers',
            options: filtersFromSSR === null || filtersFromSSR === void 0 ? void 0 : (_filtersFromSSR$more_5 = filtersFromSSR.more_filters) === null || _filtersFromSSR$more_5 === void 0 ? void 0 : _filtersFromSSR$more_5.related_influencers,
            type: 'selectInput'
          }, {
            label: t['influencer.detail.Related.video_count'],
            key: 'videos_count',
            options: filtersFromSSR === null || filtersFromSSR === void 0 ? void 0 : (_filtersFromSSR$more_6 = filtersFromSSR.more_filters) === null || _filtersFromSSR$more_6 === void 0 ? void 0 : _filtersFromSSR$more_6.videos_count,
            type: 'selectInput'
          }, {
            label: t['videos_views_count'],
            key: 'views_count',
            type: 'selectInput',
            options: filtersFromSSR === null || filtersFromSSR === void 0 ? void 0 : (_filtersFromSSR$more_7 = filtersFromSSR.more_filters) === null || _filtersFromSSR$more_7 === void 0 ? void 0 : _filtersFromSSR$more_7.views_count
          }],
          advancedFilters: [{
            key: 'seller_type',
            options: [{
              id: '1',
              key: '1',
              name: t['shops.local']
            }, {
              id: '2',
              key: '2',
              name: t['shops.cross_border']
            }],
            type: 'select',
            label: t['Delivery_Type']
          }, {
            key: 'is_s_shop',
            options: [{
              id: '1',
              key: '1',
              name: t['filter.is_yes']
            }, {
              id: '0',
              key: '0',
              name: t['filter.is_no']
            }],
            type: 'select',
            label: t['shops.filter.is_s_shop_label']
          }, {
            key: 'shop_type',
            options: [{
              id: '1',
              key: '1',
              name: t['filter.is_yes']
            }, {
              id: '0',
              key: '0',
              name: t['filter.is_no']
            }],
            type: 'select',
            label: t['is_brand_shop_label']
          }, {
            key: 'is_free_shipping',
            options: [{
              id: '1',
              key: '1',
              name: t['filter.is_yes']
            }, {
              id: '0',
              key: '0',
              name: t['filter.is_no']
            }],
            type: 'select',
            label: t['shops.filter.is_free_shipping']
          }, {
            type: 'select',
            key: 'sales_flag',
            options: [{
              id: '2',
              key: '2',
              name: t['product.filter.live_selling']
            }, {
              id: '1',
              key: '1',
              name: t['product.filter.video_selling']
            }],
            label: t['shop.detail.main_methods']
          }, {
            key: 'sales_trend_flag',
            options: [{
              id: '1',
              key: '1',
              name: t['product.filter.trend_up']
            }, {
              id: '2',
              key: '2',
              name: t['product.filter.trend_down']
            }],
            type: 'select',
            label: t['product.filter.sales_trend']
          }, {
            label: t['table.Sales'],
            key: 'sales,total_sale_cnt',
            options: [],
            type: 'multipleSelectInput',
            optionMap: {
              sales: {
                data: filtersFromSSR.more_filters.sales,
                name: t['sales_day30']
              },
              total_sale_cnt: {
                data: filtersFromSSR.more_filters.total_sold_count,
                name: t['influencer.detail.basic.contents.trend.sales.total']
              }
            }
          }, {
            label: t['gmv'],
            key: 'gmv,gmv_amt_30d',
            options: [],
            type: 'multipleSelectInput',
            optionMap: {
              gmv: {
                data: filtersFromSSR.more_filters.gmv,
                name: t['total.GMV']
              },
              gmv_amt_30d: {
                data: filtersFromSSR.more_filters.gmv_amt_30d,
                name: t['GMV30']
              }
            }
          }, {
            key: 'dateRange',
            options: dateList.map(item => ({
              id: item.value,
              key: item.value,
              name: item.label
            })),
            type: 'select',
            tooltipText: t['product.column.date_tips'],
            label: t['product.filter.time_range']
          }, {
            label: t['estimated_release_time'],
            key: 'start_time,end_time',
            type: 'dateRangePicker',
            tooltipText: t['estimated_release_time'],
            options: []
          }],
          params: params,
          onChange: nextParams => {
            if (nextParams['keyword'] === '') {
              setParams(_objectSpread({}, nextParams));
              setCurrentKeyword('');
              setResetFlag(new Date().getTime());
            } else {
              // 因为keyword不会实时更新，所以filter改变时，获取一次最新的keyword值
              setParams(_objectSpread(_objectSpread({}, nextParams), {}, {
                keyword: currentKeyword
              }));
            }

            handleChangeSEOTitle(nextParams);
          }
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_components_EchoCard__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
          children: renderTable()
        })]
      })]
    })]
  });
});
const LibrarySkeleton = _ref2 => {
  let {
    loading
  } = _ref2;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_42__/* ["default"] */ .Z, {
    loading: loading,
    text: {
      width: '90%',
      rows: 15
    },
    image: {
      shape: 'circle'
    },
    animation: true
  });
};

const ProductsWrapper = _ref3 => {
  let {
    ssrCtx,
    queryFromSSR
  } = _ref3;
  const {
    filtersFromSSR
  } = (0,_hooks_useSWRApi__WEBPACK_IMPORTED_MODULE_25__/* .useProductsFilterLocalStorage */ .n9)({
    ssrCtx
  });

  if ((0,_utils_is__WEBPACK_IMPORTED_MODULE_24__/* .isEmpty */ .xb)(filtersFromSSR)) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(LibrarySkeleton, {
      loading: true
    });
  }

  const paramsFromSSR = (0,_hooks_useUrlSyncParams__WEBPACK_IMPORTED_MODULE_5__/* .getParamsFromQueryForProduct */ .i9)(filtersFromSSR, queryFromSSR);
  return (0,_utils_is__WEBPACK_IMPORTED_MODULE_24__/* .isEmpty */ .xb)(paramsFromSSR) ? null : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__.jsx)(Products, {
    paramsFromSSR: paramsFromSSR,
    ssrCtx: ssrCtx,
    filtersFromSSR: filtersFromSSR
  });
};

/* harmony default export */ __webpack_exports__["default"] = (ProductsWrapper);

/***/ }),

/***/ 86902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ filter; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/EchoCard/index.tsx
var EchoCard = __webpack_require__(2917);
// EXTERNAL MODULE: ./src/pages/platform/leaderboard/categories.tsx + 1 modules
var categories = __webpack_require__(19781);
// EXTERNAL MODULE: ./src/utils/useLocale.ts
var useLocale = __webpack_require__(83126);
// EXTERNAL MODULE: ./src/pages/library/style/filter.module.less
var filter_module = __webpack_require__(98150);
var filter_module_default = /*#__PURE__*/__webpack_require__.n(filter_module);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Space/index.js
var Space = __webpack_require__(77303);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Button/index.js + 1 modules
var Button = __webpack_require__(56187);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Spin/index.js + 1 modules
var Spin = __webpack_require__(62258);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconClose/index.js
var IconClose = __webpack_require__(59547);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./src/utils/tree.ts
var tree = __webpack_require__(68238);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/pages/library/custom-render.tsx + 2 modules
var custom_render = __webpack_require__(16390);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Radio/index.js
var Radio = __webpack_require__(2489);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Tooltip/index.js
var Tooltip = __webpack_require__(15695);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/DatePicker/index.js + 24 modules
var DatePicker = __webpack_require__(23415);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Dropdown/index.js + 1 modules
var Dropdown = __webpack_require__(94990);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Divider/index.js
var Divider = __webpack_require__(69609);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/InputNumber/index.js + 3 modules
var InputNumber = __webpack_require__(32403);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconDown/index.js
var IconDown = __webpack_require__(31944);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconUp/index.js
var IconUp = __webpack_require__(2295);
// EXTERNAL MODULE: ./node_modules/ahooks/es/useSetState/index.js
var useSetState = __webpack_require__(96638);
// EXTERNAL MODULE: ./node_modules/ahooks/es/useUpdateEffect/index.js
var useUpdateEffect = __webpack_require__(42170);
// EXTERNAL MODULE: ./src/components/FilterItem/index.tsx
var FilterItem = __webpack_require__(21023);
// EXTERNAL MODULE: ./src/components/FilterItem/index.module.less
var index_module = __webpack_require__(91159);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./src/utils/lib.ts
var lib = __webpack_require__(38582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/pages/library/components/filter-item.tsx













const RadioGroup = Radio/* default.Group */.Z.Group;
function resRealValue(options, value) {
  let unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  let suffix = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  if (!options) return '';
  let resultText = '';
  const knowObj = options === null || options === void 0 ? void 0 : options.find(item => item.id === value);

  if (knowObj) {
    resultText = knowObj.name;
  } else {
    resultText = (0,custom_render/* transNumberToUnit */.GW)(value, unit, suffix);
  }

  return resultText;
}
function resRealAnyValue(options, value) {
  if (!options) return '';
  let resultText = '';

  if (typeof value === 'string') {
    const knowObj = options === null || options === void 0 ? void 0 : options.find(item => item.id === value);

    if (knowObj) {
      resultText = knowObj.name;
    }
  } else if (Array.isArray(value)) {
    value.forEach(val => {
      const knowObj = options === null || options === void 0 ? void 0 : options.find(item => item.id === val);

      if (knowObj) {
        resultText += `${knowObj.name}&`;
      }
    });
    if (resultText.indexOf('&') > -1) resultText = resultText.slice(0, -1);
  }

  return resultText;
}

const NewDateRangePicker = _ref => {
  let {
    params,
    onChange,
    tooltipText
  } = _ref;
  const t = (0,useLocale/* default */.Z)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: '',
    children: tooltipText ? /*#__PURE__*/(0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
      content: tooltipText,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(DatePicker/* default.RangePicker */.Z.RangePicker, {
          mode: "date",
          className: (filter_module_default()).datePicker,
          triggerProps: {
            // popupVisible: true,
            className: (filter_module_default()).datePickerPopup,
            position: 'bl'
          },
          shortcuts: [{
            text: t['product.filter.yesterday'],
            value: () => [dayjs_min_default()().startOf('day'), dayjs_min_default()().subtract(1, 'days').startOf('day')]
          }, {
            text: t['product.filter.last_week'],
            value: () => [dayjs_min_default()().startOf('day'), dayjs_min_default()().subtract(7, 'days').startOf('day')]
          }, {
            text: t['product.filter.last_month'],
            value: () => [dayjs_min_default()().startOf('day'), dayjs_min_default()().subtract(30, 'days').startOf('day')]
          }, {
            text: t['product.filter.last90'],
            value: () => [dayjs_min_default()().startOf('day'), dayjs_min_default()().subtract(90, 'days').startOf('day')]
          }],
          disabledDate: current => current.isAfter(dayjs_min_default()()),
          defaultPickerValue: [dayjs_min_default()().month(dayjs_min_default()().month() - 1), dayjs_min_default()()],
          value: params['start_time'] && params['end_time'] ? [dayjs_min_default().unix(params['start_time']), dayjs_min_default().unix(params['end_time'])] : undefined,
          onChange: (_, date) => {
            onChange({
              start_time: date ? String(date === null || date === void 0 ? void 0 : date[0].unix()) : '',
              end_time: date ? String(date === null || date === void 0 ? void 0 : date[1].unix()) : ''
            });
          }
        })
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(DatePicker/* default.RangePicker */.Z.RangePicker, {
      mode: "date",
      className: (filter_module_default()).datePicker,
      triggerProps: {
        // popupVisible: true,
        className: (filter_module_default()).datePickerPopup,
        position: 'left'
      },
      shortcuts: [{
        text: t['product.filter.yesterday'],
        value: () => [dayjs_min_default()().startOf('day'), dayjs_min_default()().subtract(1, 'days').startOf('day')]
      }, {
        text: t['product.filter.last_week'],
        value: () => [dayjs_min_default()().startOf('day'), dayjs_min_default()().subtract(7, 'days').startOf('day')]
      }, {
        text: t['product.filter.last_month'],
        value: () => [dayjs_min_default()().startOf('day'), dayjs_min_default()().subtract(30, 'days').startOf('day')]
      }, {
        text: t['product.filter.last90'],
        value: () => [dayjs_min_default()().startOf('day'), dayjs_min_default()().subtract(90, 'days').startOf('day')]
      }],
      disabledDate: current => current.isAfter(dayjs_min_default()()),
      defaultPickerValue: [dayjs_min_default()().month(dayjs_min_default()().month() - 1), dayjs_min_default()()],
      value: params['start_time'] && params['end_time'] ? [dayjs_min_default().unix(params['start_time']), dayjs_min_default().unix(params['end_time'])] : undefined,
      onChange: (_, date) => {
        onChange({
          start_time: date ? String(date === null || date === void 0 ? void 0 : date[0].unix()) : '',
          end_time: date ? String(date === null || date === void 0 ? void 0 : date[1].unix()) : ''
        });
      }
    })
  });
};

const NewMultipleCheckbox = _ref2 => {
  let {
    filter,
    params,
    onChange
  } = _ref2;
  const optionMap = filter.optionMap;
  const keys = (0,react.useMemo)(() => Object.keys(optionMap ? optionMap : {}) || [], [optionMap]);
  const [state, setState] = (0,useSetState/* default */.Z)({});
  (0,useUpdateEffect/* default */.Z)(() => {
    Object.keys(params).forEach(key => {
      if (keys.includes(key)) {
        // url有默认值
        setState({
          [key]: params[key]
        });
      }
    });
  }, [params]);

  const DropList = () => {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (filter_module_default())["multiple-checkbox-wrap"],
      children: keys === null || keys === void 0 ? void 0 : keys.map(key => {
        var _optionMap$key, _optionMap$key$data;

        return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (filter_module_default())["multiple-checkbox-item"],
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
            className: (filter_module_default())["multiple-checkbox-item-label"],
            children: [optionMap === null || optionMap === void 0 ? void 0 : optionMap[key].name, "\uFF1A"]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (filter_module_default())["multiple-checkbox-item-result"],
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(RadioGroup, {
              value: state[key],
              defaultValue: (params === null || params === void 0 ? void 0 : params[key]) || '',
              onChange: value => {
                setState({
                  [key]: value
                });
                onChange === null || onChange === void 0 ? void 0 : onChange({
                  [key]: value
                });
              },
              children: optionMap === null || optionMap === void 0 ? void 0 : (_optionMap$key = optionMap[key]) === null || _optionMap$key === void 0 ? void 0 : (_optionMap$key$data = _optionMap$key.data) === null || _optionMap$key$data === void 0 ? void 0 : _optionMap$key$data.map(item => {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(Radio/* default */.Z, {
                  value: item.id,
                  children: item.name
                }, item.id);
              })
            })
          })]
        }, key);
      })
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Dropdown/* default */.Z, {
      droplist: /*#__PURE__*/(0,jsx_runtime.jsx)(DropList, {}),
      position: "bl",
      trigger: 'click',
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (filter_module_default())["trigger-button"],
        children: [filter.label, " ", /*#__PURE__*/(0,jsx_runtime.jsx)(IconDown/* default */.Z, {
          style: {
            paddingLeft: 10
          }
        })]
      })
    })
  });
};

const NewMultipleSelectInput = _ref3 => {
  let {
    filter,
    params,
    onChange
  } = _ref3;
  const t = (0,useLocale/* default */.Z)();
  const optionMap = filter.optionMap;
  const keys = (0,react.useMemo)(() => Object.keys(optionMap ? optionMap : {}) || [], [optionMap]);
  const {
    0: currentKey,
    1: setCurrentKey
  } = (0,react.useState)((keys === null || keys === void 0 ? void 0 : keys[0]) || '');
  const {
    0: currentValue,
    1: setCurrentValue
  } = (0,react.useState)(undefined);
  const {
    0: minValue,
    1: setMinValue
  } = (0,react.useState)();
  const {
    0: maxValue,
    1: setMaxValue
  } = (0,react.useState)();
  const {
    0: popupVisible,
    1: setPopupVisible
  } = (0,react.useState)(false);
  const currentOptions = (0,react.useMemo)(() => {
    var _optionMap$currentKey;

    const data = (optionMap === null || optionMap === void 0 ? void 0 : (_optionMap$currentKey = optionMap[currentKey]) === null || _optionMap$currentKey === void 0 ? void 0 : _optionMap$currentKey.data) || []; // 扁平化数组，处理可能存在的嵌套数组情况

    return data.flat();
  }, [currentKey, optionMap]); // 初始化：只在 params 变化时同步状态

  (0,react.useEffect)(() => {
    // 如果 popup 打开中，不执行任何同步逻辑，避免干扰用户操作
    if (popupVisible) {
      return;
    } // 根据 params 传进来的值做回显


    const paramKey = keys.find(key => params[key]);

    if (paramKey && params[paramKey]) {
      const paramValue = params[paramKey]; // 检查当前状态是否已经和 params 同步

      const isAlreadySynced = currentKey === paramKey && currentValue === paramValue;

      if (!isAlreadySynced) {
        var _optionMap$paramKey;

        setCurrentKey(paramKey);
        setCurrentValue(paramValue); // 使用当前 key 对应的 options 来判断

        const options = ((optionMap === null || optionMap === void 0 ? void 0 : (_optionMap$paramKey = optionMap[paramKey]) === null || _optionMap$paramKey === void 0 ? void 0 : _optionMap$paramKey.data) || []).flat();
        const active = options === null || options === void 0 ? void 0 : options.find(d => d.id === paramValue);

        if (active) {
          setMinValue(undefined);
          setMaxValue(undefined);
        } else {
          //自定义输入的，需要拆分出 min 和 max
          if (paramValue !== null && paramValue !== void 0 && paramValue.includes('-')) {
            const [min, max] = paramValue.split('-');
            setMinValue(Number(min));
            setMaxValue(Number(max));
          } else if (paramValue !== null && paramValue !== void 0 && paramValue.includes('>')) {
            const min = paramValue.replace('>', '');
            setMinValue(Number(min));
            setMaxValue(undefined);
          } else if (paramValue !== null && paramValue !== void 0 && paramValue.includes('<')) {
            const max = paramValue.replace('<', '');
            setMinValue(undefined);
            setMaxValue(Number(max));
          }
        }
      }
    } else {
      // params 中不包含 keys 里的任何值，说明参数被外部重置了，重置所有状态
      const hasAnyValue = currentValue !== undefined || minValue !== undefined || maxValue !== undefined;

      if (hasAnyValue) {
        setCurrentKey(keys[0] || '');
        setCurrentValue(undefined);
        setMinValue(undefined);
        setMaxValue(undefined);
      }
    }
  }, [params, optionMap, keys, currentKey, currentValue, minValue, maxValue, popupVisible]);
  const triggerText = (0,react.useMemo)(() => {
    // 选项显示
    const active = currentOptions === null || currentOptions === void 0 ? void 0 : currentOptions.find(d => d.id === currentValue && currentValue !== undefined);

    if (currentValue && active) {
      if (active) {
        var _optionMap$currentKey2;

        return `${(optionMap === null || optionMap === void 0 ? void 0 : (_optionMap$currentKey2 = optionMap[currentKey]) === null || _optionMap$currentKey2 === void 0 ? void 0 : _optionMap$currentKey2.name) || filter.label}: ${active.name}`;
      } else {
        //自定义输入的
        if (minValue && maxValue) {
          var _optionMap$currentKey3;

          return `${(optionMap === null || optionMap === void 0 ? void 0 : (_optionMap$currentKey3 = optionMap[currentKey]) === null || _optionMap$currentKey3 === void 0 ? void 0 : _optionMap$currentKey3.name) || filter.label}: ${minValue}-${maxValue}`;
        } else if (minValue) {
          var _optionMap$currentKey4;

          return `${(optionMap === null || optionMap === void 0 ? void 0 : (_optionMap$currentKey4 = optionMap[currentKey]) === null || _optionMap$currentKey4 === void 0 ? void 0 : _optionMap$currentKey4.name) || filter.label}: >${minValue}`;
        } else if (maxValue) {
          var _optionMap$currentKey5;

          return `${(optionMap === null || optionMap === void 0 ? void 0 : (_optionMap$currentKey5 = optionMap[currentKey]) === null || _optionMap$currentKey5 === void 0 ? void 0 : _optionMap$currentKey5.name) || filter.label}: <${maxValue}`;
        }
      }
    } else if (currentValue && !active) {
      if (minValue && maxValue) {
        var _optionMap$currentKey6;

        return `${(optionMap === null || optionMap === void 0 ? void 0 : (_optionMap$currentKey6 = optionMap[currentKey]) === null || _optionMap$currentKey6 === void 0 ? void 0 : _optionMap$currentKey6.name) || filter.label}: ${minValue}-${maxValue}`;
      } else if (minValue) {
        var _optionMap$currentKey7;

        return `${(optionMap === null || optionMap === void 0 ? void 0 : (_optionMap$currentKey7 = optionMap[currentKey]) === null || _optionMap$currentKey7 === void 0 ? void 0 : _optionMap$currentKey7.name) || filter.label}: >${minValue}`;
      } else if (maxValue) {
        var _optionMap$currentKey8;

        return `${(optionMap === null || optionMap === void 0 ? void 0 : (_optionMap$currentKey8 = optionMap[currentKey]) === null || _optionMap$currentKey8 === void 0 ? void 0 : _optionMap$currentKey8.name) || filter.label}: <${maxValue}`;
      }
    } else if (!currentValue && !active) {
      return filter.label;
    } else {
      var _optionMap$currentKey9;

      return (optionMap === null || optionMap === void 0 ? void 0 : (_optionMap$currentKey9 = optionMap[currentKey]) === null || _optionMap$currentKey9 === void 0 ? void 0 : _optionMap$currentKey9.name) || filter.label;
    }
  }, [currentKey, currentValue, filter.label, currentOptions, optionMap, minValue, maxValue]);
  const handleReset = (0,react.useCallback)(() => {
    setCurrentValue(undefined);
    onChange === null || onChange === void 0 ? void 0 : onChange({
      [currentKey]: undefined
    });
    setMinValue(undefined);
    setMaxValue(undefined);
    setPopupVisible(false);
  }, [currentKey, onChange]);
  const handleOk = (0,react.useCallback)(() => {
    // 先要清空其他选项
    keys.filter(key => key !== currentKey).forEach(key => {
      onChange === null || onChange === void 0 ? void 0 : onChange({
        [key]: undefined
      });
    }); // 优先使用自定义输入的值（minValue 或 maxValue）

    if (minValue || maxValue) {
      if (minValue && maxValue) {
        setCurrentValue(`${minValue}-${maxValue}`);
        onChange === null || onChange === void 0 ? void 0 : onChange({
          [currentKey]: `${minValue}-${maxValue}`
        });
      } else if (minValue) {
        setCurrentValue(`>${minValue}`);
        onChange === null || onChange === void 0 ? void 0 : onChange({
          [currentKey]: `>${minValue}`
        });
      } else if (maxValue) {
        setCurrentValue(`<${maxValue}`);
        onChange === null || onChange === void 0 ? void 0 : onChange({
          [currentKey]: `<${maxValue}`
        });
      }
    }

    setPopupVisible(false);
  }, [keys, currentKey, currentValue, minValue, maxValue, onChange]);
  const handleItemClick = (0,react.useCallback)(id => {
    // 先要清空其他选项
    keys.filter(key => key !== currentKey).forEach(key => {
      onChange === null || onChange === void 0 ? void 0 : onChange({
        [key]: undefined
      });
    });
    setCurrentValue(id);
    onChange === null || onChange === void 0 ? void 0 : onChange({
      [currentKey]: id
    });
    setMinValue(undefined);
    setMaxValue(undefined);
    setPopupVisible(false);
  }, [keys, currentKey, onChange]);
  const handleKeyChange = (0,react.useCallback)(value => {
    // 清空其他 key 的值
    keys.forEach(key => {
      if (key !== value) {
        onChange === null || onChange === void 0 ? void 0 : onChange({
          [key]: undefined
        });
      }
    });
    setCurrentKey(value);
    setMinValue(undefined);
    setMaxValue(undefined);
    setCurrentValue(undefined);
  }, [keys, onChange]);
  const DropList = (0,react.useMemo)(() => {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (filter_module_default())["multiple-select-input-wrap"],
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "flex flex-col gap-2 pr-2",
        style: {
          borderRight: '1px solid #e1e3ee',
          whiteSpace: 'nowrap',
          width: 'auto',
          minWidth: 'fit-content'
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(RadioGroup, {
          direction: "vertical",
          value: currentKey,
          onChange: handleKeyChange,
          children: keys.map(key => {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(Radio/* default */.Z, {
              value: key,
              children: optionMap === null || optionMap === void 0 ? void 0 : optionMap[key].name
            }, key);
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col gap-2 pl-2",
        children: [currentOptions === null || currentOptions === void 0 ? void 0 : currentOptions.map(item => {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            onClick: () => handleItemClick(item.id),
            className: (0,lib.cn)('cursor-pointer hover:text-primary hover:bg-gray-100 rounded-md px-1 py-2', currentValue === item.id && 'text-primary bg-gray-100'),
            children: item.name
          }, item.key);
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Divider/* default */.Z, {
          className: "my-2"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "p-2",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "flex items-center gap-2 mb-2",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(InputNumber/* default */.Z, {
              min: 0,
              className: (index_module_default()).customInput,
              hideControl: true,
              size: "small",
              value: minValue,
              onChange: val => setMinValue(val)
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: (filter_module_default()).hyphen,
              children: "-"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(InputNumber/* default */.Z, {
              min: 0,
              className: (index_module_default()).customInput,
              hideControl: true,
              size: "small",
              value: maxValue,
              onChange: val => setMaxValue(val)
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "flex items-center justify-between",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
              type: "text",
              size: "small",
              onClick: handleReset,
              children: t['common.list.reset']
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
              className: (index_module_default()).okBtn,
              type: "primary",
              size: "small",
              onClick: handleOk,
              children: t['common.list.ok']
            })]
          })]
        })]
      })]
    });
  }, [currentKey, keys, optionMap, currentOptions, currentValue, minValue, maxValue, handleItemClick, handleKeyChange, handleReset, handleOk, t]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Dropdown/* default */.Z, {
      droplist: DropList,
      position: "bl",
      trigger: 'click',
      popupVisible: popupVisible,
      onVisibleChange: visible => {
        setPopupVisible(visible);
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (filter_module_default())["trigger-button"],
        onClick: e => {
          e.stopPropagation();
          setPopupVisible(true);
        },
        children: [triggerText, ' ', popupVisible ? /*#__PURE__*/(0,jsx_runtime.jsx)(IconUp/* default */.Z, {
          style: {
            paddingLeft: 10
          }
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(IconDown/* default */.Z, {
          style: {
            paddingLeft: 10
          }
        })]
      })
    })
  });
};

const NewFilterItem = _ref4 => {
  var _filter$options;

  let {
    filter,
    params,
    onChange,
    type
  } = _ref4;

  const handleChange = value => {
    onChange === null || onChange === void 0 ? void 0 : onChange({
      [filter.key]: value
    });
  };

  if (type === 'multipleCheckbox') {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(NewMultipleCheckbox, {
      filter: filter,
      params: params,
      onChange: onChange
    });
  }

  if (type === 'dateRangePicker') {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(NewDateRangePicker, {
      params: params,
      onChange: onChange,
      tooltipText: filter.tooltipText || ''
    });
  }

  if (type === 'multipleSelectInput') {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(NewMultipleSelectInput, {
      filter: filter,
      params: params,
      onChange: onChange
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(FilterItem/* default */.Z, {
    tooltipText: filter.tooltipText || '',
    title: filter.label,
    data: ((_filter$options = filter.options) === null || _filter$options === void 0 ? void 0 : _filter$options.map(item => ({
      label: item.name,
      value: item.id
    }))) || [],
    type: type,
    onChange: handleChange,
    defaultValue: params[filter.key]
  });
};
// EXTERNAL MODULE: ./node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__(50361);
var cloneDeep_default = /*#__PURE__*/__webpack_require__.n(cloneDeep);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Typography/index.js + 11 modules
var Typography = __webpack_require__(15734);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Message/index.js + 1 modules
var Message = __webpack_require__(80507);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Input/index.js + 6 modules
var Input = __webpack_require__(1393);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Menu/index.js + 11 modules
var Menu = __webpack_require__(28096);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Empty/index.js
var Empty = __webpack_require__(43061);
// EXTERNAL MODULE: ./src/pages/library/style/custom-filter.module.less
var custom_filter_module = __webpack_require__(58177);
var custom_filter_module_default = /*#__PURE__*/__webpack_require__.n(custom_filter_module);
// EXTERNAL MODULE: ./src/components/EchoModal/index.tsx
var EchoModal = __webpack_require__(28330);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconEdit/index.js
var IconEdit = __webpack_require__(61803);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconDelete/index.js
var IconDelete = __webpack_require__(61873);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconMoreVertical/index.js
var IconMoreVertical = __webpack_require__(73153);
// EXTERNAL MODULE: ./src/utils/useLocalStorageWithExpiry.ts
var useLocalStorageWithExpiry = __webpack_require__(57153);
;// CONCATENATED MODULE: ./src/pages/library/components/custom-filter.tsx













const {
  Text
} = Typography/* default */.Z;
const CustomFilterSaveButton = _ref => {
  let {
    params,
    results,
    saveSuccessCallback
  } = _ref;
  const t = (0,useLocale/* default */.Z)();
  const router = (0,next_router.useRouter)();
  const {
    0: currentName,
    1: setCurrentName
  } = (0,react.useState)('');
  const {
    0: visible,
    1: setVisible
  } = (0,react.useState)(false);
  const {
    0: inputStatus,
    1: setInputStatus
  } = (0,react.useState)(undefined);
  const {
    0: modalType,
    1: setModalType
  } = (0,react.useState)('new');
  const {
    0: currentResults,
    1: setCurrentResults
  } = (0,react.useState)(results || []);
  const {
    getItemWithExpiry,
    setItemWithExpiry
  } = (0,useLocalStorageWithExpiry/* default */.Z)({
    key: `${router.pathname}_custom_filter_list`,
    expiryInMinutes: null
  });
  const tableList = getItemWithExpiry() || [];
  (0,useUpdateEffect/* default */.Z)(() => {
    setCurrentResults(results);
  }, [results]);

  const handleOk = () => {
    if (!currentName) {
      setInputStatus('error');
      Message/* default.error */.Z.error(t['information.name']);
      return;
    }

    if ((results === null || results === void 0 ? void 0 : results.length) === 0) {
      Message/* default.error */.Z.error(t['filer_empty']);
      return;
    }

    if (tableList.filter(item => item.name === currentName).length > 0) {
      setInputStatus('error');
      Message/* default.error */.Z.error(t['name_canot_repeated']);
      return;
    }

    if (modalType === 'new') {
      const list = cloneDeep_default()(tableList);

      list.push({
        params: params,
        results: results,
        name: currentName,
        key: currentName
      });
      setItemWithExpiry(list);
      Message/* default.success */.Z.success(t['favorite.create_success']);
      setTimeout(() => {
        saveSuccessCallback === null || saveSuccessCallback === void 0 ? void 0 : saveSuccessCallback();
      });
    }

    setVisible(false);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
      style: {
        borderRadius: 16
      },
      onClick: () => {
        setModalType('new');
        setCurrentName('');
        setVisible(true);
      },
      children: t['save_current_filter']
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(EchoModal/* default */.Z, {
      visible: visible,
      onCancel: () => setVisible(false),
      title: `${modalType === 'edit' ? t['monitor.btn.edit'] : t['userSetting.btn.save']}${t['current_filter']}`,
      onOk: handleOk,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (custom_filter_module_default())["modal-content-row"],
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
            className: (custom_filter_module_default())["modal-content-label"],
            children: [t['common.filter.filtering'], ":"]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (custom_filter_module_default())["modal-content-result-list"],
            children: currentResults.map((result, index) => {
              return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text, {
                  children: result.text
                }), index === currentResults.length - 1 ? null : /*#__PURE__*/(0,jsx_runtime.jsx)(Divider/* default */.Z, {
                  type: "vertical"
                })]
              }, index);
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (custom_filter_module_default())["modal-content-row"],
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
            className: (custom_filter_module_default())["modal-content-label"],
            children: [t['filer_name'], ":"]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Input/* default */.Z, {
            placeholder: t['custom_filter_placeholder'],
            style: {
              width: 400
            },
            value: currentName,
            onChange: v => {
              setCurrentName(v);
            },
            status: inputStatus
          })]
        })]
      })
    })]
  });
};
const CustomFilterListButton = _ref2 => {
  let {
    params,
    results,
    onChange
  } = _ref2;
  const t = (0,useLocale/* default */.Z)();
  const router = (0,next_router.useRouter)();
  const {
    0: currentName,
    1: setCurrentName
  } = (0,react.useState)('');
  const {
    0: visible,
    1: setVisible
  } = (0,react.useState)(false);
  const {
    0: delVisible,
    1: setDelVisible
  } = (0,react.useState)(false);
  const {
    0: inputStatus,
    1: setInputStatus
  } = (0,react.useState)(undefined);
  const {
    0: modalType,
    1: setModalType
  } = (0,react.useState)('new');
  const {
    0: editData,
    1: setEditData
  } = (0,react.useState)();
  const {
    0: currentResults,
    1: setCurrentResults
  } = (0,react.useState)(results || []);
  const {
    getItemWithExpiry,
    setItemWithExpiry
  } = (0,useLocalStorageWithExpiry/* default */.Z)({
    key: `${router.pathname}_custom_filter_list`,
    expiryInMinutes: null
  });
  const tableList = getItemWithExpiry() || [];
  (0,useUpdateEffect/* default */.Z)(() => {
    setCurrentResults(results);
  }, [results]); // useUpdateEffect(() => {
  //   console.log('当前值', tableList)
  //   setTableList(cloneDeep(tableList))
  // }, [updateFlag])

  const handleOk = () => {
    if (!currentName) {
      setInputStatus('error');
      Message/* default.error */.Z.error(t['information.name']);
      return;
    }

    if ((results === null || results === void 0 ? void 0 : results.length) === 0) {
      Message/* default.error */.Z.error(t['filer_empty']);
      return;
    }

    if (tableList.filter(item => item.name === currentName).length > 0) {
      setInputStatus('error');
      Message/* default.error */.Z.error(t['name_canot_repeated']);
      return;
    }

    if (modalType === 'new') {
      const list = cloneDeep_default()(tableList);

      list.push({
        params: params,
        results: results,
        name: currentName,
        key: currentName
      });
      setItemWithExpiry(list);
      Message/* default.success */.Z.success(t['favorite.create_success']);
    } else {
      const list = cloneDeep_default()(tableList);

      const _index = list.findIndex(item => item.key === (editData === null || editData === void 0 ? void 0 : editData.key));

      if (_index > -1) {
        list[_index].name = currentName;
        setItemWithExpiry(list);
        Message/* default.success */.Z.success(t['edit_success']);
      }
    }

    setVisible(false);
  };

  const onClickMenuItem = (key, item) => {
    onChange === null || onChange === void 0 ? void 0 : onChange(item.params);
  };

  const EditDropList = _ref3 => {
    let {
      data
    } = _ref3;
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(Menu/* default */.Z, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Menu/* default.Item */.Z.Item, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (custom_filter_module_default())["drop-list-item"],
          onClick: () => {
            setModalType('edit');
            setEditData(data);
            setCurrentResults(data.results);
            setCurrentName(data.name);
            setVisible(true);
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconEdit/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: t['rename']
          })]
        })
      }, "1"), /*#__PURE__*/(0,jsx_runtime.jsx)(Menu/* default.Item */.Z.Item, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (custom_filter_module_default())["drop-list-item"],
          onClick: () => {
            setModalType('edit');
            setEditData(data);
            setDelVisible(true);
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconDelete/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: t['favorite.delete']
          })]
        })
      }, "2")]
    });
  };

  const DropList = () => {
    return tableList.length === 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      style: {
        background: '#fff',
        padding: '10px 20px'
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Empty/* default */.Z, {})
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Menu/* default */.Z, {
      children: tableList.map(item => {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Menu/* default.Item */.Z.Item, {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (custom_filter_module_default())["drop-list-item"],
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              style: {
                paddingRight: 20
              },
              onClick: () => onClickMenuItem(item.name, item),
              children: item.name
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Dropdown/* default */.Z, {
              droplist: /*#__PURE__*/(0,jsx_runtime.jsx)(EditDropList, {
                data: item
              }),
              trigger: "hover",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(IconMoreVertical/* default */.Z, {
                style: {
                  marginRight: 0
                }
              })
            })]
          })
        }, item.name);
      })
    });
  };

  return tableList.length === 0 ? null : /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (custom_filter_module_default())["custom-filter-wrap"],
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Dropdown/* default */.Z, {
      droplist: /*#__PURE__*/(0,jsx_runtime.jsx)(DropList, {}),
      trigger: "click",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Button/* default */.Z, {
        style: {
          borderRadius: 8
        },
        children: [t['quick_filer'], /*#__PURE__*/(0,jsx_runtime.jsx)(IconDown/* default */.Z, {})]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(EchoModal/* default */.Z, {
      visible: visible,
      onCancel: () => setVisible(false),
      title: `${modalType === 'edit' ? t['monitor.btn.edit'] : t['userSetting.btn.save']}${t['current_filter']}`,
      onOk: handleOk,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (custom_filter_module_default())["modal-content-row"],
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
            className: (custom_filter_module_default())["modal-content-label"],
            children: [t['common.filter.filtering'], ":"]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (custom_filter_module_default())["modal-content-result-list"],
            children: currentResults.map((result, index) => {
              return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text, {
                  children: result.text
                }), index === currentResults.length - 1 ? null : /*#__PURE__*/(0,jsx_runtime.jsx)(Divider/* default */.Z, {
                  type: "vertical"
                })]
              });
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (custom_filter_module_default())["modal-content-row"],
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
            className: (custom_filter_module_default())["modal-content-label"],
            children: [t['filer_name'], ":"]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Input/* default */.Z, {
            placeholder: t['custom_filter_placeholder'],
            style: {
              width: 400
            },
            value: currentName,
            onChange: v => {
              setCurrentName(v);
            },
            status: inputStatus
          })]
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(EchoModal/* default */.Z, {
      title: t['monitor.jump.tip'],
      visible: delVisible,
      onCancel: () => setDelVisible(false),
      onOk: () => {
        const list = cloneDeep_default()(tableList);

        const _index = list.findIndex(item => item.key === (editData === null || editData === void 0 ? void 0 : editData.key));

        if (_index > -1) {
          list.splice(_index, 1);
          setItemWithExpiry(list);
          Message/* default.success */.Z.success(t['favorite.delete_success']);
        }

        setDelVisible(false);
      },
      children: t['favorite.sure_delete']
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/library/filter.tsx


















function Filter(props) {
  const {
    categoryFilters,
    params,
    onChange,
    style,
    loading,
    id,
    showCustomFilter,
    advancedFilters = [],
    basicFilters = []
  } = props;
  const t = (0,useLocale/* default */.Z)();
  const router = (0,next_router.useRouter)();
  const {
    0: update,
    1: setUpdate
  } = (0,react.useState)(Date.now());

  const commonDelete = filter => {
    if (router.query[`${filter.key}_name_slug`]) {
      onChange({
        [filter.key]: undefined,
        [`${filter.key}_name_slug`]: 'all'
      });
    } else {
      const keyList = filter.key.split(',');

      if (keyList.length > 1) {
        keyList.map(key => {
          onChange({
            [key]: undefined
          });
        });
      } else {
        onChange({
          [filter.key]: undefined
        });
      }
    }
  };

  const handleFilterResultItem = filter => {
    const keyList = filter.key.split(',');

    if (keyList.length <= 1 && !params[filter.key]) {
      return;
    }

    const resObj = {
      onDelete: () => {
        commonDelete(filter);
      }
    };
    const labelText = filter.label;

    if (filter.type === 'select') {
      var _filter$options;

      const value = params[filter.key];
      const curObj = (_filter$options = filter.options) === null || _filter$options === void 0 ? void 0 : _filter$options.find(option => option.id === value);

      if (curObj) {
        resObj.text = `${filter.label}: ${curObj.name}`;
      }
    }

    if (filter.type === 'selectInput') {
      const resText = resRealValue(filter.options, params[filter.key], filter === null || filter === void 0 ? void 0 : filter.unit, filter === null || filter === void 0 ? void 0 : filter.suffix);
      resObj.text = `${labelText}: ${resText}`;
    }

    if (filter.type === 'dateRangePicker') {
      // 多个key
      const startTimeKey = keyList[0];
      const endTimeKey = keyList[1];
      resObj.text = `${labelText}:${dayjs_min_default().unix(params[startTimeKey]).format('YYYY-MM-DD')}-${dayjs_min_default().unix(params[endTimeKey]).format('YYYY-MM-DD')}`;

      if (!params[startTimeKey]) {
        return;
      }
    }

    if (filter.type === 'multipleCheckbox') {
      const filerKeys = Object.keys(filter.optionMap);
      let curKey = '';
      let resultText = '';
      filerKeys === null || filerKeys === void 0 ? void 0 : filerKeys.map((key, index) => {
        if (params[key]) {
          var _filter$optionMap, _filter$optionMap2;

          curKey = key;
          const customOptions = (_filter$optionMap = filter.optionMap) !== null && _filter$optionMap !== void 0 && _filter$optionMap[key] ? (_filter$optionMap2 = filter.optionMap) === null || _filter$optionMap2 === void 0 ? void 0 : _filter$optionMap2[key].data : [];
          const currentObj = customOptions.find(item => item.id === params[key]);
          resultText += `${currentObj === null || currentObj === void 0 ? void 0 : currentObj.name}${index === filerKeys.length - 1 ? '' : '/'}`;
        }
      });
      const labelText = filter.label;
      resObj.text = `${labelText}: ${resultText}`;

      if (!params[curKey]) {
        return;
      }
    }

    if (filter.type === 'multipleSelectInput') {
      const filerKeys = Object.keys(filter.optionMap);
      let curKey = '';
      let resultText = '';
      let resultLabel = '';
      filerKeys === null || filerKeys === void 0 ? void 0 : filerKeys.map((key, index) => {
        if (params[key]) {
          var _filter$optionMap3, _filter$optionMap4, _filter$optionMap5, _filter$optionMap5$ke;

          curKey = key;
          const customOptions = (_filter$optionMap3 = filter.optionMap) !== null && _filter$optionMap3 !== void 0 && _filter$optionMap3[key] ? (_filter$optionMap4 = filter.optionMap) === null || _filter$optionMap4 === void 0 ? void 0 : _filter$optionMap4[key].data : [];
          resultLabel = ((_filter$optionMap5 = filter.optionMap) === null || _filter$optionMap5 === void 0 ? void 0 : (_filter$optionMap5$ke = _filter$optionMap5[key]) === null || _filter$optionMap5$ke === void 0 ? void 0 : _filter$optionMap5$ke.name) || '';
          const currentObj = customOptions.find(item => item.id === params[key]);
          resultText += currentObj ? `${currentObj === null || currentObj === void 0 ? void 0 : currentObj.name}` : `${params[key]}`;
        }
      });
      resObj.text = `${resultLabel}: ${resultText}`;

      if (!params[curKey]) {
        return;
      }
    }

    return resObj;
  };

  const generateFilterResult = () => {
    const categoryFiltersResult = categoryFilters.map(filter => {
      var _filter$categories, _filter$categories$fi;

      const id = params[filter.key];

      if (!id) {
        return;
      }

      let categoryResultText = '';

      if (id && filter !== null && filter !== void 0 && filter.threeLevelList) {
        const treeList = (0,tree/* transTree */.B)((filter === null || filter === void 0 ? void 0 : filter.threeLevelList) || []);

        if (Array.isArray(id)) {
          if (id.length === 1 && id[0] === '') return;
          id.forEach(id => {
            const curObj = treeList.find(item => item.value === id);
            categoryResultText += `${curObj === null || curObj === void 0 ? void 0 : curObj.label}/`;
          });
          categoryResultText = categoryResultText.slice(0, -1);
        } else if (typeof id === 'string') {
          const curObj = treeList.find(item => item.value === id);
          categoryResultText = `${curObj === null || curObj === void 0 ? void 0 : curObj.label}`;
        }
      }

      const labelText = (filter === null || filter === void 0 ? void 0 : filter.resultLabel) || (filter === null || filter === void 0 ? void 0 : filter.label);
      return {
        text: filter !== null && filter !== void 0 && filter.threeLevelList ? `${labelText}: ${categoryResultText}` : `${labelText}: ${(_filter$categories = filter.categories) === null || _filter$categories === void 0 ? void 0 : (_filter$categories$fi = _filter$categories.find(item => item.id === params[filter.key])) === null || _filter$categories$fi === void 0 ? void 0 : _filter$categories$fi.name}`,
        onDelete: () => {
          if (router.query[`${filter.key}_name_slug`]) {
            onChange({
              [filter.key]: filter !== null && filter !== void 0 && filter.threeLevelList ? filter === null || filter === void 0 ? void 0 : filter.threeLevelList[0].value : filter.categories[0].id,
              [`${filter.key}_name_slug`]: 'all'
            });
          } else {
            onChange({
              [filter.key]: filter !== null && filter !== void 0 && filter.threeLevelList ? filter === null || filter === void 0 ? void 0 : filter.threeLevelList[0].value : filter.categories[0].id
            });
          }
        }
      };
    }).filter(Boolean);
    const basicFiltersResult = (basicFilters === null || basicFilters === void 0 ? void 0 : basicFilters.map(filter => handleFilterResultItem(filter)).filter(Boolean)) || [];
    const newFiltersResult = (advancedFilters === null || advancedFilters === void 0 ? void 0 : advancedFilters.map(filter => handleFilterResultItem(filter)).filter(Boolean)) || [];
    const searchResults = [{
      key: 'keyword',
      label: t['search_keywords']
    }].map(filter => {
      if (!params[filter.key]) {
        return;
      }

      const value = params[filter.key];
      return {
        text: `${filter.label}: ${value}`,
        onDelete: () => {
          onChange({
            [filter.key]: ''
          });
        }
      };
    }).filter(Boolean);
    return [...categoryFiltersResult, ...searchResults, ...basicFiltersResult, ...newFiltersResult];
  }; // 基础筛选


  const renderBasicFilters = () => {
    return basicFilters.length > 0 ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: classnames_default()((filter_module_default()).label, (filter_module_default()).labelText),
        children: t['common.list.condition_filter']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: 'flex justify-between flex-1',
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (filter_module_default()).newFilters,
          children: basicFilters.map(item => {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(NewFilterItem, {
              filter: item,
              params: params,
              onChange: onChange,
              type: item.type
            }, item.key);
          })
        })
      })]
    }) : null;
  }; // 新版高级筛选


  const renderNewFilter = () => {
    return advancedFilters.length > 0 ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: classnames_default()((filter_module_default()).label, (filter_module_default()).labelText),
        children: t['common.list.advance_filter']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: 'flex justify-between flex-1',
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (filter_module_default()).newFilters,
          children: advancedFilters.map(item => {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(NewFilterItem, {
              filter: item,
              params: params,
              onChange: onChange,
              type: item.type
            }, item.key);
          })
        })
      })]
    }) : null;
  };

  const renderFilterResult = () => {
    const result = generateFilterResult();
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (filter_module_default()).filterResult,
      children: result.length ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: classnames_default()((filter_module_default()).label, (filter_module_default()).labelText),
          children: t['common.filter.filtering']
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (filter_module_default()).filterResultWrap,
          children: [result.map((item, index) => {
            return (item === null || item === void 0 ? void 0 : item.onDelete) && /*#__PURE__*/(0,jsx_runtime.jsx)(categories/* RadioButton */.EU, {
              onClick: item === null || item === void 0 ? void 0 : item.onDelete,
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Space/* default */.Z, {
                children: [item === null || item === void 0 ? void 0 : item.text, /*#__PURE__*/(0,jsx_runtime.jsx)(IconClose/* default */.Z, {})]
              })
            }, index);
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            type: "outline",
            shape: "round",
            className: (filter_module_default()).clearBtn,
            onClick: () => {
              result.forEach(item => (item === null || item === void 0 ? void 0 : item.onDelete) && (item === null || item === void 0 ? void 0 : item.onDelete()));
            },
            children: t['common.filter.clear']
          }), showCustomFilter && /*#__PURE__*/(0,jsx_runtime.jsx)(CustomFilterSaveButton, {
            params: params,
            results: generateFilterResult(),
            saveSuccessCallback: () => setUpdate(Date.now())
          })]
        })]
      }) : null
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(EchoCard/* default */.Z, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Spin/* default */.Z, {
      loading: loading,
      block: true,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Space/* default */.Z, {
        direction: "vertical",
        size: "small",
        className: (filter_module_default()).filtersWrap,
        style: style,
        children: [categoryFilters.map(filter => {
          if (filter !== null && filter !== void 0 && filter.threeLevelList) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(categories/* DropdownCategories */.QM, {
              id: filter.key,
              label: filter.label,
              value: params[filter.key],
              onValuesChange: values => {
                let level1Obj = undefined;

                if (Array.isArray(values)) {
                  level1Obj = filter.categories.find(c => c.id === values[0]);
                }

                if (router.query[`${filter.key}_name_slug`]) {
                  var _level1Obj;

                  onChange({
                    [filter.key]: values,
                    [`${filter.key}_name_slug`]: ((_level1Obj = level1Obj) === null || _level1Obj === void 0 ? void 0 : _level1Obj.name_slug) || 'all'
                  });
                } else {
                  onChange({
                    [filter.key]: values
                  });
                }
              },
              labelClassName: (filter_module_default()).label,
              threeLevelList: filter.threeLevelList
            }, filter.key);
          }

          return /*#__PURE__*/(0,jsx_runtime.jsx)(categories/* default */.ZP, {
            id: filter.key,
            label: filter.label,
            value: params[filter.key],
            onChange: value => {
              var _filter$categories2;

              const nameSlugObj = (_filter$categories2 = filter.categories) === null || _filter$categories2 === void 0 ? void 0 : _filter$categories2.find(c => c.id === value);

              if (router.query[`${filter.key}_name_slug`]) {
                onChange({
                  [filter.key]: value,
                  [`${filter.key}_name_slug`]: (nameSlugObj === null || nameSlugObj === void 0 ? void 0 : nameSlugObj.name_slug) || 'all'
                });
              } else {
                onChange({
                  [filter.key]: value
                });
              }
            },
            categories: filter.categories,
            labelClassName: (filter_module_default()).label
          }, filter.key);
        }), renderBasicFilters(), renderNewFilter()]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (filter_module_default()).actionsWrap,
        children: [renderFilterResult(), showCustomFilter && /*#__PURE__*/(0,jsx_runtime.jsx)(CustomFilterListButton, {
          params: params,
          results: generateFilterResult(),
          onChange: onChange
        })]
      })]
    })
  });
}

/* harmony default export */ var filter = (Filter);

/***/ })

}]);